module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [(this.typeactivity === 'scaled') ? _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    attrs: {
      "to": '/Reassignment/' + this.$route.params.id
    }
  }, [_c('button', {
    staticClass: "btn btn-success"
  }, [_vm._v("Reasignar PQR")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("PQR " + _vm._s(this.$route.params.id))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "pqr_form"
    }
  }, [_c('div', {
    staticClass: "panel-group pqr_panel",
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "href": "javascript:;",
      "id": "btn-search"
    },
    on: {
      "click": function($event) {
        _vm.pqrDisplay = !_vm.pqrDisplay
      }
    }
  }, [_vm._v("Creación de PQR")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pqrDisplay),
      expression: "pqrDisplay"
    }],
    attrs: {
      "id": "collapse1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('emt-form', {
    ref: "acount-form",
    attrs: {
      "itemsFormPqr": _vm.itemsFormPqr,
      "itemsFormAccount": _vm.itemsFormAccount,
      "itemsFormAttachment": _vm.itemsFormAttachment,
      "updateData": _vm.update,
      "resource": _vm.itemResource,
      "typeactivity": _vm.typeactivity
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "btn-login"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "btningresar",
      "name": "btningresar"
    },
    on: {
      "click": function($event) {
        _vm.reasignados()
      }
    }
  }, [_vm._v("Ver reasignaciones")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "panel-group pqr_panel pqr_panel",
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "href": "javascript:;",
      "id": "btn-search"
    },
    on: {
      "click": function($event) {
        _vm.pqrDisplayActivity = !_vm.pqrDisplayActivity
      }
    }
  }, [_vm._v("Respuesta de EPM")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pqrDisplayActivity),
      expression: "pqrDisplayActivity"
    }],
    attrs: {
      "id": "collapse1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('emt-form', {
    ref: "acount-form",
    attrs: {
      "itemsFormActivity": _vm.itemsFormActivity,
      "itemsFormActivityAttachment": _vm.itemsFormActivityAttachment,
      "resource": _vm.itemResource,
      "typeactivity": _vm.typeactivity
    },
    on: {
      "changeEmail": _vm.enabledEmailsActivity
    }
  })], 1)])])]), _vm._v(" "), (this.activityProvider === 'waiting_provider' || this.activityProvider == true) ? _c('div', {
    staticClass: "panel-group pqr_panel pqr_panel",
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "href": "javascript:;",
      "id": "btn-search"
    },
    on: {
      "click": function($event) {
        _vm.pqrDisplayActivityProvider = !_vm.pqrDisplayActivityProvider
      }
    }
  }, [_vm._v("Respuesta de proveedor")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pqrDisplayActivityProvider),
      expression: "pqrDisplayActivityProvider"
    }],
    attrs: {
      "id": "collapse1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('emt-form', {
    ref: "acount-form",
    attrs: {
      "itemsFormActivityProvider": _vm.itemsFormActivityProvider,
      "itemsFormProviderAttachment": _vm.itemsFormProviderAttachment,
      "resource": _vm.itemResource,
      "typeactivity": _vm.typeactivity
    },
    on: {
      "changeEmail": _vm.enabledEmailsActivityProvider
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (this.typeactivity === 'pending' || this.typeactivity === 'closed') ? _c('div', {
    staticClass: "panel-group pqr_panel pqr_panel",
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "href": "javascript:;",
      "id": "btn-search"
    },
    on: {
      "click": function($event) {
        _vm.pqrDisplayActivityClosed = !_vm.pqrDisplayActivityClosed
      }
    }
  }, [_vm._v("Cierre de PQR")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pqrDisplayActivityClosed),
      expression: "pqrDisplayActivityClosed"
    }],
    attrs: {
      "id": "collapse1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('emt-form', {
    ref: "acount-form",
    attrs: {
      "itemsFormActivityClosed": _vm.itemsFormActivityClosed,
      "itemsFormClosedAttachment": _vm.itemsFormClosedAttachment,
      "resource": _vm.itemResource,
      "typeactivity": _vm.typeactivity
    },
    on: {
      "change": _vm.changelist
    }
  })], 1)])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f97e90a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/emt-form-update-pqr.vue
// module id = 197
// module chunks = 0